import { NgModule } from '@angular/core';
import { LockerSizePage } from './locker-size.page';
import { SharedModule } from 'app/shared.module';
import { OfferLockerComponent } from 'app/components/shared/offer-locker/offer-locker.component';

@NgModule({
  imports: [
    SharedModule,
    OfferLockerComponent
  ],
  declarations: [LockerSizePage]
})
export class LockerSizePageModule {}
